const ERROR_MESSAGES = {
    "VALIDATION_EXCEPTION": "Die Validierung der angegebenen Daten ist fehlgeschlagen.",
    "DATABASE_QUERY_EXCEPTION": "Ein unbekannter Datenbankfehler ist aufgetreten.",
    "MODEL_EXCEPTION__NOT_FOUND": "Die Resource konnte nicht gefunden werden.",

    "API_EXCEPTION__UNIQUE_TIME_SHEET_SETTING": "Es existieren bereits eine Arbeitszeit-Einstellung für den gegebenen Zeitraum.",
    "API_EXCEPTION__TIME_SHEET_SETTINGS_REQUIRED": "Es sind keine Arbeitszeit-Einstellung verfügbar."
};

export default ERROR_MESSAGES;